import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoIdiomasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoIdiomasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoIdiomasService(): Observable<BodyListResponse<CatalogoIdiomasDTO>> {
    return this.http.get<BodyListResponse<CatalogoIdiomasDTO>>(API_URL + '/api/v1/catalogoIdiomas/todos');
  }

  guardarCatalogoIdiomasService(catalogoIdiomasDTO: CatalogoIdiomasDTO): Observable<CatalogoIdiomasDTO> {
    return this.http.post<CatalogoIdiomasDTO>(API_URL + '/api/v1/catalogoIdiomas', catalogoIdiomasDTO);
  } 

  getCatalogoIdiomasPorCodigoCatalogoIdiomaService(codigoCatalogoIdioma: string): Observable<BodyResponse<CatalogoIdiomasDTO>> {
    return this.http.get<BodyResponse<CatalogoIdiomasDTO>>(API_URL + '/api/v1/catalogoIdiomas/' + codigoCatalogoIdioma);
  }
}
